import {
  MenuItem, Typography,
} from '@mui/material';
import { ProjectFieldsFragment } from '../../../../../../../generated/core-api/graphql-react-query';
import useProjectIdContext from '../../../../../../Contexts/ProjectContexts/ProjectIdContext/useProjectIdContext';
import useProjectInfoContext from '../../../../../../Contexts/ProjectContexts/ProjectInfoContext/useProjectInfoContext';
import StyledMenu from './styles';

interface SelectProjectMenuProps {
  options: ProjectFieldsFragment[];
  anchorEl: null | HTMLElement;
  onClose: () => void;
}

export default function SelectProjectMenu(props: SelectProjectMenuProps) {
  const { options } = props;
  const { anchorEl, onClose } = props;
  const { setProjectId, projectId: current } = useProjectIdContext();
  const { projects } = useProjectInfoContext();
  return (
    <StyledMenu
      anchorEl={anchorEl}
      open={!!anchorEl}
      onClose={onClose}
    >
      {!projects && (<div>No projects found</div>)}
      {options.map((project) => (
        <MenuItem
          dense
          key={project.id}
          onClick={() => {
            setProjectId(project.id);
            onClose();
          }}
          title={project.name}
          selected={project.id === current}
        >
          <Typography variant="inherit" noWrap>
            {project.name}
          </Typography>
        </MenuItem>
      ))}
    </StyledMenu>
  );
}
